import React from 'react';
import { Form } from '../../../ui/universe';
import { Switch, Tooltip } from 'tdesign-react';

/**
 * TDesign Switch 参数渲染器
 */
function TdSwitchRenderer({ params, value, onChange }) {
  return (
    <Form.Item
      className={`${params.LabelAlign ? 'column' : 'row'}`}
      label={
        <>
          <span>{params.label}</span>
          {params.des && (
            <Tooltip content={params.des} theme="light">
              <span className="ocrDemo-icon-question"></span>
            </Tooltip>
          )}
        </>
      }
    >
      <Switch
        value={value}
        onChange={(val) => {
          onChange && onChange(val);
        }}
      />
    </Form.Item>
  );
}

export default TdSwitchRenderer;
